import React from "react";

// Nebulosa azul de fundo: 5 manchas radiais azuis, sutis, atrás dos canvases
// animados (ParticleGridBackground / WarpBackground) e do conteúdo, pra dar
// profundidade -- efeito adaptado do mockup fusao-grid-particulas.html (ver
// comentários em ParticleGridBackground.js e WarpBackground.js).
//
// position:fixed (em vez de um background no <body>) evita de saída a
// "costura" horizontal que apareceria em páginas mais altas que a viewport
// se isso fosse um background-image comum no body sem background-attachment
// fixed -- um elemento fixed nunca se move com o scroll, então não existe
// esse corte pra começo de conversa. Mantemos background-attachment:"fixed"
// mesmo assim só por fidelidade ao efeito original (é redundante aqui, mas
// inofensivo).
//
// Uso: <Nebulosa /> como primeiro filho, antes do canvas animado da tela
// (ParticleGridBackground/WarpBackground), nas 3 telas do mockup original
// (Landing, Login, Dashboard). Fica atrás de tudo (zIndex -1) e nunca
// atrapalha cliques/scroll.
export default function Nebulosa() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: -1,
        pointerEvents: "none",
        backgroundColor: "var(--bg, #0f1117)",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundImage: [
          "radial-gradient(circle at 12% 18%, rgba(37,99,235,0.20), transparent 42%)",
          "radial-gradient(circle at 88% 12%, rgba(59,130,246,0.16), transparent 46%)",
          "radial-gradient(circle at 80% 78%, rgba(29,78,216,0.18), transparent 42%)",
          "radial-gradient(circle at 8% 82%, rgba(96,165,250,0.14), transparent 46%)",
          "radial-gradient(circle at 50% 50%, rgba(37,99,235,0.08), transparent 60%)",
        ].join(", "),
      }}
    />
  );
}
